import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { colorPrimary } from "../../constants/colors";
import { IButtonIconProps } from "./ButtonIcon.props";
import styles from "./ButtonIcon.module.scss";
import { useAppSelector } from "@/store/hooks";
import { selectHintsEnabled } from "@/store/hintsSlice";
import { forwardRef } from "react";

const ButtonIcon = forwardRef<HTMLButtonElement, IButtonIconProps>(
	({ className, hint = "", hintPosition, icon, iconSize = "xl", iconColor = colorPrimary, title, ...props }, ref): JSX.Element => {
		const hintsEnabled = useAppSelector(selectHintsEnabled);

		return (
			<button ref={ref} className={cn(styles.button, className)} type="button" title={hintsEnabled ? "" : title} {...props}>
				<FontAwesomeIcon icon={icon} size={iconSize} color={iconColor} />
			</button>
		);
	}
);

export default ButtonIcon;
